import React from 'react';

export const CircleCheckmark = ({
  alt,
  height = 52,
  width = 52,
}: {
  alt: string;
  height?: number;
  width?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby="cricleCheckTitle"
  >
    <title id="circleCheckTitle">{alt}</title>
    <circle className="fill-brand-03" cx="26" cy="26" r="26" />
    <path
      d="M36.1182 17.9033C36.6064 18.3954 36.6064 19.1891 36.1182 19.6811L22.6242 33.2843C22.2331 33.6786 21.5955 33.6786 21.2043 33.2843L15.8818 27.9187C15.3936 27.4266 15.3936 26.633 15.8818 26.1409C16.3755 25.6432 17.1802 25.6432 17.674 26.1409L21.9143 30.4155L34.3261 17.9033C34.8198 17.4056 35.6245 17.4056 36.1182 17.9033Z"
      fill="#000000"
      stroke="#000000"
      strokeWidth="2"
    />
  </svg>
);
